'use client'

import { useState } from 'react'
import { Card, CardContent, CardFooter } from '../components/ui/card'
import { Button } from '../components/ui/button'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../components/ui/collapsible'
import PersonProfile from '../components/PersonProfile'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronDown, ChevronUp, Code } from 'lucide-react'

export function sanitizeBoldOnly(html) {
    // 모든 태그를 escape
    let safe = html.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    // <b>와 </b>만 복원
    safe = safe.replace(/&lt;b&gt;/g, "<b>").replace(/&lt;\/b&gt;/g, "</b>");
    return safe;
}

export default function OriginalMAList({ items, onSelect, selectedMA, people, isExpanded = false, originalIndex, useOriginalIndex = false }) {
    const [expandedMA, setExpandedMA] = useState(null)

    const toggleExpand = (id) => {
        setExpandedMA(expandedMA === id ? null : id)
    }

    return (
        <div className="h-full flex flex-col">
            <div className="flex-1 overflow-y-auto pb-4">
                <div className="space-y-4 p-4">
                    {items.map((ma, index) => {
                        const foo = people.find((p) => p.id === ma.foo)
                        const isSelected = selectedMA?.id === ma.id
                        const shouldExpand = expandedMA === ma.id || (isSelected && isExpanded)
                        const displayIndex = originalIndex !== undefined ? originalIndex : (useOriginalIndex ? index + 1 : index + 1)

                        return (
                            <motion.div
                                key={ma.id}
                                layout
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -10 }}
                                transition={{ duration: 0.2 }}
                                className={`relative ${isSelected ? 'scale-105' : ''}`}
                            >
                                <Card
                                    className={`transition-all cursor-pointer ${isSelected ? 'ring-2 ring-primary shadow-lg' : ''}`}
                                    onClick={() => {
                                        if (isSelected) {
                                            onSelect(null);
                                        } else {
                                            onSelect(ma);
                                        }
                                    }}
                                >
                                    <CardContent className={`${isSelected ? 'pt-8' : 'pt-6'} pb-2`}>
                                        <div className="flex justify-between items-start mb-2">
                                            <div className="flex items-start gap-3">
                                                <span className={`${isSelected ? 'text-xl' : 'text-xl'} font-bold text-primary min-w-[2.5rem]`}>
                                                    {displayIndex}.
                                                </span>
                                                <p
                                                    className={`${isSelected ? 'text-lg' : 'text-lg'}`}
                                                    dangerouslySetInnerHTML={{ __html: sanitizeBoldOnly(ma.text) }}
                                                />
                                            </div>
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                className="ml-2 h-8 w-8 p-0"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleExpand(ma.id);
                                                }}
                                            >
                                                {shouldExpand ? (
                                                    <ChevronUp className="h-5 w-5" />
                                                ) : (
                                                    <ChevronDown className="h-5 w-5" />
                                                )}
                                            </Button>
                                        </div>

                                        {shouldExpand && (
                                            <motion.div
                                                initial={{ opacity: 0, height: 0 }}
                                                animate={{ opacity: 1, height: 'auto' }}
                                                exit={{ opacity: 0, height: 0 }}
                                                className="mb-2"
                                            >
                                            </motion.div>
                                        )}
                                    </CardContent>

                                    <CardFooter className="flex justify-between border-t pt-2">
                                        <div className="flex items-center gap-2">
                                            <span className="text-sm font-medium text-primary bg-primary/10 px-2 py-1 rounded-full">
                                                {ma.domain}
                                            </span>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </motion.div>
                        )
                    })}
                </div>
                <div className="flex items-center justify-between mt-4 flex-col gap-2">
                    <div className="flex items-center gap-2">
                        <span className="text-sm text-muted-foreground">EmoSync</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="text-sm text-muted-foreground">CHI 2025</span>
                    </div>
                </div>
            </div>
        </div>
    )
} 